import {Component, inject, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {GatewayOrderCreateComponent} from "./gateway-order-create/gateway-order-create.component";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from "@angular/material/table";
import {FormBuilder, FormControl, ReactiveFormsModule} from "@angular/forms";
import {GatewayOrder} from "../../model/gateway/gatewayOrder";
import {GatewayOrderService} from "../../service/gateway.order.service";
import {HttpErrorResponse} from "@angular/common/http";
import {Router} from "@angular/router";
import {debounceTime, Observable} from "rxjs";

@Component({
  selector: 'app-gateway',
  standalone: true,
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCellDef,
    MatCell,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    ReactiveFormsModule
  ],
  templateUrl: './gateway.component.html',
  styleUrl: './gateway.component.css'
})
export class GatewayComponent implements OnInit {
  private readonly FORM_WIDTH = '60%';

  private dialog = inject(MatDialog);
  private formBuilder = inject(FormBuilder);
  private gatewayOrderService = inject(GatewayOrderService);
  private router = inject(Router);

  gatewayOrders: GatewayOrder[] = [];
  error = "";

  dataSource = new MatTableDataSource<GatewayOrder>(this.gatewayOrders);
  displayedColumns = ['gatewayOrderId', 'orderName', 'gatewayOrderType', 'environmentKey',
    'creatorEmail', 'createdDateTime'];

  filterForm = this.createFilterForm();

  createGatewayOrder() {
    const dialogRef = this.dialog.open(GatewayOrderCreateComponent, {
      width: this.FORM_WIDTH
    });

    dialogRef.afterClosed().subscribe(() => this.getGatewayOrders(this.filterForm.controls.imei.value));
  }

  goToGatewayOrder(gatewayOrder: GatewayOrder) {
    void this.router.navigate(['gateway/' + gatewayOrder.gatewayOrderId]);
  }

  private createFilterForm() {
    const form = this.formBuilder.group({
      imei: new FormControl<string | null>(null)
    });

    form.valueChanges.pipe(debounceTime(500)).subscribe((changes) => {
      this.getGatewayOrders(this.normalizeImei(changes.imei));
    });

    return form;
  }

  private getGatewayOrders(imei: string | null) {
    imei = this.normalizeImei(imei);

    if (imei) {
      this.processResponse(this.gatewayOrderService.findByImei(imei));
    } else {
      this.processResponse(this.gatewayOrderService.getAll());
    }
  }

  private processResponse(observable: Observable<GatewayOrder[]>) {
    return observable.subscribe({
      next: response => {
        this.gatewayOrders = response;
        this.dataSource = new MatTableDataSource<GatewayOrder>(this.gatewayOrders);
      },
      error: err => {
        if (err instanceof HttpErrorResponse) {
          console.log("Unable to retrieve gateway orders: " + err.status + " " + err.message);
          this.error = err.message;
        }
      }
    });
  }

  private normalizeImei(imei: string | null | undefined) {
    return imei?.trim() || null;
  }

  ngOnInit() {
    this.getGatewayOrders(null);
  }
}
